import React from "react";
import { Line } from "react-chartjs-2";
import EnsaConstant from "../../../pages/Reports/ensa/EnsaConstant";

const ChartLineKesenjanganLiterasi = ({dataProgres, listTitle}) => {
    let listProgres = dataProgres
    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
        },
    };
    let titleLaki = listTitle
    let titlePrem = listTitle
    let titles = [...titleLaki, ...titlePrem]
    let dataLaki = []
    let dataPrem = []
    for (let i in listProgres.laki) {
        const item = listProgres.laki[i]
        dataLaki.push(item.value)
    }
    for (let i in listProgres.perempuan) {
        const item = listProgres.perempuan[i]
        dataPrem.push(item.value)
    }
    let listData = [...dataLaki, ...dataPrem]
    const data = {
        labels: titles,
        datasets: [
            {
                label: "",
                data: listData,
                pointStyle: "circle",
                pointRadius: 5,
                pointHoverRadius: 10,
                fill: false,
                showLine: false,
                borderWidth: 1,
                backgroundColor: EnsaConstant.COLOR.CHART_LINE_LITERASI,
                borderColor: EnsaConstant.COLOR.CHART_LINE_LITERASI,
            },
        ],
    };

    return (
        <div style={{ width: '100%' }}>
            <div style={{ width: '100%', display: 'flex', gap: '20px', paddingLeft: '14%', paddingRight: '2%' }}>
                <div style={{ width: '50%', textAlign: 'center' }}>Laki - Laki</div>
                <div style={{ width: '59%', textAlign: 'center' }}>Perempuan</div>
            </div>
            <Line data={data} options={options} height={300} />
        </div>
    );
};

export default ChartLineKesenjanganLiterasi;
